import { PUBLIC_EVENT_STATUS } from '@/features/publicsite/events/eventStatus';
import type { EventDetail } from '@/features/publicsite/types/events/EventDetail';

/**
 * Whether /harta has a marker for this event, and so whether "Vezi pe hartă" has anything to show.
 *
 * The backend places an event by its raion and takes a cancelled one off the map
 * (EventService.syncGeoPoint). The link used to follow the raion alone, so on a cancelled event it
 * opened a map saying "Niciun rezultat găsit.".
 */
export function eventIsOnMap(event: Pick<EventDetail, 'regionId' | 'status'>): boolean {
  return Boolean(event.regionId) && event.status !== PUBLIC_EVENT_STATUS.cancelled;
}
